import Close from '@/src/assets/icons/Close'
import { Button } from '@/src/common/components/Button'
import { Input } from '@/src/common/components/Input'
import { formatCurrency } from '@/src/common/utils/general'
import { useEffect, useState } from 'react'
import { Dialog, Button as TamaguiButton, useEvent } from 'tamagui'
import { E2E } from '..'

export function UpdateAmountDialog({
  isOpen,
  initialValue,
  onOpenChange,
  onUpdate,
}: {
  isOpen: boolean
  initialValue: number
  onOpenChange: (open: boolean) => void
  onUpdate: (value: number) => void
}) {
  const [value, setValue] = useState(0)
  const handleUpdate = () => {
    onUpdate(value)
    onOpenChange(false)
  }

  useEffect(() => {
    setValue(initialValue)
  }, [initialValue])

  const handleChangeText = useEvent((value: string) => {
    const numericValue = value.replace(/[^0-9]/g, '')
    setValue(numericValue ? Number(numericValue) : 0)
  })

  return (
    <Dialog modal defaultOpen open={isOpen} onOpenChange={onOpenChange}>
      <Dialog.Portal>
        <Dialog.Overlay
          key="overlay"
          animateOnly={['transform', 'opacity']}
          animation={[
            'quicker',
            {
              opacity: {
                overshootClamping: true,
              },
            },
          ]}
          enterStyle={{ opacity: 0 }}
          exitStyle={{ opacity: 0 }}
          style={{ backgroundColor: 'black', opacity: 0.5 }}
        />
        <Dialog.Content key="content" p="$4" gap="$4">
          <Input
            keyboardType="numeric"
            label="Monthly housing payment"
            value={
              value === 0
                ? ''
                : formatCurrency(value, {
                    decimals: 0,
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 0,
                  })
            }
            onChangeText={handleChangeText}
            testID={E2E.Config.Ids.Input.MonthlyHousingPayment}
          />
          <Button
            title="Update"
            onPress={handleUpdate}
            segmentAction="MesaHome MortgagePayment SubmitUpdatedMonthlyHousingPayment"
            segmentComponent="Button"
            testID={E2E.Config.Ids.Press.Update}
          />
          <Dialog.Close asChild>
            <TamaguiButton
              r="$2"
              t="$2"
              position="absolute"
              size="$2"
              circular
              icon={<Close width={16} height={16} />}
            />
          </Dialog.Close>
        </Dialog.Content>
      </Dialog.Portal>

      <Dialog.Adapt when="maxMd" platform="touch">
        <Dialog.Sheet
          animation="medium"
          zIndex={200000}
          dismissOnSnapToBottom
          dismissOnOverlayPress
          modal
          snapPointsMode="fit"
          moveOnKeyboardChange
        >
          <Dialog.Sheet.Handle />
          <Dialog.Sheet.Frame p="$4" gap="$4" pb="$8" minH={350}>
            <Dialog.Adapt.Contents />
          </Dialog.Sheet.Frame>
          <Dialog.Sheet.Overlay
            key="sheet-overlay"
            style={{ backgroundColor: 'black', opacity: 0.5 }}
            animateOnly={['transform', 'opacity']}
            animation={[
              'quicker',
              {
                opacity: {
                  overshootClamping: true,
                },
              },
            ]}
            enterStyle={{ opacity: 0 }}
            exitStyle={{ opacity: 0 }}
          />
        </Dialog.Sheet>
      </Dialog.Adapt>
    </Dialog>
  )
}
